import { cateringRequest } from '@/utils/fetch'

// 网页授权
export function wxAuth(params?: any) {
  const url = '/api/wechat/auth'
  return cateringRequest.get(url, {
    params
  })
}
